import slice from './slice';

export const {
  setMapType,
  setMapZoom,
  setMapCenter,
  setMapLocation,
  resetMapLocation,
} = slice.actions;